module.exports = {
  I18NEXT_DEFAULT_NAMESPACE: 'translation',
  I18N_SERVICE_URL: process.env.I18N_SERVICE_URL || 'https://translate.sf.gov'
}
